import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import confettiDesktop from '../../../../images/Confetti-Desktop.svg';
import confettiTablet from '../../../../images/Confetti-Tablet.svg';
import confettiMobile from '../../../../images/Confetti-Mobile.svg';

export const PHXLaunchWrapperStyles = css`
  &.phx-launch-campaign {
    background: ${themeGet('colors.velvet')};
    background-image: none;
    background-image: url(${confettiMobile}),
      linear-gradient(
        to bottom,
        ${themeGet('colors.velvet')} 60%,
        ${themeGet('colors.pc-red', '#E1251B')} 40%
      );
    background-repeat: no-repeat;
    background-position: 50% 270%;
    padding: 16px;
    min-height: 600px;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      padding: 24px;
    }

    @media only screen and (min-width: 414px) {
      min-height: 640px;
      background-position: 50% 230%;
    }

    @media only screen and (min-width: 600px) {
      background-image: url(${confettiDesktop}),
        linear-gradient(
          to bottom,
          ${themeGet('colors.velvet')} 60%,
          ${themeGet('colors.pc-red', '#E1251B')} 40%
        );
      background-position: 50% -180%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background-image: url(${confettiTablet}),
        linear-gradient(
          to right,
          ${themeGet('colors.velvet')} 60%,
          ${themeGet('colors.pc-red', '#E1251B')} 40%
        );
      background-position: 130% 50%;
      min-height: auto;
    }

    @media only screen and (min-width: 850px) {
      background-position: 120% 50%;
    }

    @media only screen and (min-width: 950px) {
      background-position: 110% 50%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      background-image: url(${confettiDesktop}),
        linear-gradient(
          to right,
          ${themeGet('colors.velvet')} 60%,
          ${themeGet('colors.pc-red', '#E1251B')} 40%
        );
      background-position: 205% 50%;
      padding: 40px 50px;
    }

    @media only screen and (min-width: 1075px) {
      background-position: 165% 50%;
    }

    @media only screen and (min-width: 1100px) {
      background-position: 150% 50%;
    }

    @media only screen and (min-width: 1200px) {
      background-position: 130% 50%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      background-image: url(${confettiDesktop}),
        linear-gradient(
          to right,
          ${themeGet('colors.velvet')} 55%,
          ${themeGet('colors.pc-red', '#E1251B')} 45%
        );
      background-position: 120% 50%;
      padding: 50px 70px;
    }
  }
`;

export const PHXLaunchContentStyles = css`
  ${PHXLaunchWrapperStyles}.phx-launch-campaign & {
    width: 100%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 50%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      &:lang(fr) {
        width: 45%;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      &:lang(fr) {
        width: 50%;
      }
    }
  }
`;

export const PHXLaunchTitleStyles = css`
  ${PHXLaunchWrapperStyles}.phx-launch-campaign & {
    font-size: 2rem;
    line-height: 2.25rem;
    color: ${themeGet('colors.pc-red', '#E1251B')};

    @media only screen and (min-width: 414px) {
      font-size: 2.75rem;
      line-height: 3rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 3.275rem;
      line-height: 3.375rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 4.5rem;
      line-height: 4.5rem;
    }

    sup {
      top: -0.25em;

      &:lang(fr) {
        top: -1.65em;
        font-size: 35%;
      }
    }
  }
`;

export const PHXLaunchIntroStyles = css`
  ${PHXLaunchWrapperStyles}.phx-launch-campaign & {
    max-width: none;
    margin: 24px 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 15px 0;
      max-width: 375px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 30px 0;
      max-width: unset;
    }

    p {
      font-weight: ${themeGet('fontWeights.bold')};
      color: ${themeGet('colors.white')};
      font-size: 1rem;
      line-height: 1.5rem;

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        font-size: 1.5rem;
        line-height: 2rem;
      }
    }
  }
`;

export const PHXLaunchCTAWrapperStyles = css`
  ${PHXLaunchWrapperStyles}.phx-launch-campaign & {
    padding: 0;
  }
`;

export const PHXLaunchMediaContainerStyles = css`
  ${PHXLaunchWrapperStyles}.phx-launch-campaign & {
    margin: 0;
    z-index: 1;
    position: absolute;
    width: 265px;
    height: 290px;
    top: 55%;
    right: 50%;
    transform: translateX(50%);

    @media only screen and (min-width: 414px) {
      top: 60%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      /* unset doesn't exist in IE 11 using auto instead */
      top: auto;
      bottom: -10%;
      right: 20%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 345px;
      height: 380px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 455px;
      height: 500px;
    }

    img {
      height: 290px;

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        height: 380px;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        height: 500px;
      }
    }
  }
`;
